import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export const PANEL_ID = 'social-accounts-connection-modal-panel';

export interface SocialAccountConnectionProps {
  panelId?: string;
}

export const openSocialAccountConnectionModal = (props: SocialAccountConnectionProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_ACCOUNTS_CONNECTION_MODAL,
      panelProps: props,
    })
  );
};
